import styled from "styled-components";
import { deviceDF } from "../breakPoints";

export const NavStyled = styled.nav`
  padding: 1.2rem 0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 120px;
  box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 8%);
  box-shadow: 0 17px 35px 0px rgb(0 0 0 / 7%);
`;
export const NavItemContainer = styled.div`
  width: 33.3%;
  display: flex;
  justify-content: center;
`;
export const LogoStyled = styled.img`
  height: 70px;
  @media ${deviceDF.laptoL} {
    height: 55px;
  }
  @media ${deviceDF.laptop} {
    height: 53px;
  }
  
  @media ${deviceDF.mobileS} {
    height:31px;
  }
  @media ${deviceDF.mobileM} {
    height:33px;
  }
  @media ${deviceDF.mobileL} {
    height:35px;
  }
`;
export const LogoCFDI = styled.img`
  height: 70px;
  @media ${deviceDF.laptoL} {
    height: 55px;
  }
  @media ${deviceDF.laptop} {
    height: 65px;
  }
  @media ${deviceDF.mobileM} {
    height:60px;
  }
  
`;
export const Title = styled.h1`
  font-size: 38px;
  color: #000;
  font-family: "Jost", Helvetica, Arial, sans-serif;
  @media ${deviceDF.laptoL} {
    font-size: 30px;
  }
  @media ${deviceDF.laptop} {
    font-size: 27px;
  }
  @media ${deviceDF.mobileL} {
    font-size: 24px;
  }
  @media ${deviceDF.mobileM} {
    font-size: 23px;
  }
  @media ${deviceDF.mobileS} {
    font-size: 22px;
  }
  
`;
